module.exports = __webpack_public_path__ + "img/chanpin.069f227c.png";